import type { StateStorage } from 'zustand/middleware';
import { LocalStorage } from './local-storage';

/**
 * Create a Zustand storage object that uses LocalStorage as the storage backend.
 * @param prefix the prefix to use for the storage keys
 * @returns A Zustand storage object
 */
export function createZustandStorage(prefix: string): StateStorage {
  return {
    getItem: async (name: string) => {
      return LocalStorage.get(createKey(prefix, name)) ?? null;
    },
    setItem: async (name: string, value: string) => {
      LocalStorage.set(createKey(prefix, name), value);
    },
    removeItem: async (name: string) => {
      LocalStorage.remove(createKey(prefix, name));
    },
  };
}

/*
|------------------
| Internals
|------------------
*/

function createKey(prefix: string, name: string) {
  return `zstd:${prefix}:${name}`;
}
